module.exports = __webpack_public_path__ + "img/Transport_1200x800.0bfa458d.png";